<ion-app color="secondary">
  <ion-router-outlet [environmentInjector]="environmentInjector"></ion-router-outlet>
  <app-loading [loading]="loading$ | async"></app-loading>
  <!-- To be used by loading state -->
  <app-loading class="frame-stack-110000" [loading]="loadingWithSpinner$ | async"></app-loading>
  <ion-icon class="swipe-back" id="swipe-back" name="arrow-back-circle"></ion-icon>
</ion-app>
